import script from "./InvitesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitesPage.vue?vue&type=script&setup=true&lang=js"

export default script